import styled from "styled-components";
import { Button } from "../Button";
import { videoButtonSpacings } from "./VideoButton.utils";
export const StyledVideoButton = styled(Button) `
  width: ${({ size }) => `${videoButtonSpacings[size].height}px`};
  height: ${({ size }) => `${videoButtonSpacings[size].height}px`};
  border-radius: 50%;
  min-width: unset;
  padding: unset;

  span {
    display: flex;
    justify-content: center;
    align-items: center;

    svg {
      width: ${({ size }) => `${videoButtonSpacings[size].icon}px`};
      height: ${({ size }) => `${videoButtonSpacings[size].icon}px`};
    }

    &:disabled:active {
      transform: none;
    }
  }
`;
